import session from './session';
import makeUrl from './url/make-url';
import serializeQueryParams from './url/serialize-query-params';

export const clearAuthTokenAndUpdateUrl = () => {
    clearAuthTokenBasedOnQueryParam();

    clearAuthUrl();
};

export const clearAuthUrl = () => {
    const queryParams = serializeQueryParams();

    if (queryParams.clear_auth !== undefined) {
        delete queryParams.clear_auth;
        const newUrl = makeUrl(window.location.pathname, {}, queryParams);

        window.history.replaceState({}, document.title, newUrl);
    }
};

export const clearAuthTokenBasedOnQueryParam = () => {
    const queryParams = serializeQueryParams();

    if (queryParams.clear_auth !== undefined) {
        session.clearAccessToken();
    }
};
